import { service } from '@/utils/request'



export default {
    /** 近义词Api */
    // 近义词 编辑、添加
    saveEsSynonymWords: (data) => {
        return service({
            url: '/cloud/search/admin/esSearch/saveEsSynonymWords',
            method: 'post',
            data
        })
    },
    // 近义词 分页列表
    esSynonymPages: (data) => {
        return service({
            url: '/cloud/search/admin/esSearch/esSynonymPages',
            method: 'post',
            data
        })
    },
    // 近义词 删除
    deleteEsSynonymWords: (params) => {
        return service({
            url: '/cloud/search/admin/esSearch/deleteEsSynonymWords',
            method: 'delete',
            params
        })
    },
    // 近义词 上下架
    changeEsSynonymWords: (params) => {
        return service({
            url: '/cloud/search/admin/esSearch/changeEsSynonymWords',
            method: 'put',
            params
        })
    },
    /** 扩展词 */
    // 扩展词 添加
    saveEsExtWords: (data) => {
        return service({
            url: '/cloud/search/admin/esSearch/saveEsExtWords',
            method: 'post',
            data
        })
    },
    // 扩展词 分页列表
    esExtWordsPages: (data) => {
        return service({
            url: '/cloud/search/admin/esSearch/esExtWordsPages',
            method: 'post',
            data
        })
    },
    // 扩展词 删除
    deleteEsExtWords: (params) => {
        return service({
            url: '/cloud/search/admin/esSearch/deleteEsExtWords',
            method: 'delete',
            params
        })
    },
    // 扩展词 上下架
    changeEsExtWords: (params) => {
        return service({
            url: '/cloud/search/admin/esSearch/changeEsExtWords',
            method: 'put',
            params
        })
    },
    /** 停用词 */
    // 停用词 新增
    saveEsStopWords: (data) => {
        return service({
            url: '/cloud/search/admin/esSearch/saveEsStopWords',
            method: 'post',
            data
        })
    },
    // 停用词 分页列表
    esStopWordsPages: (data) => {
        return service({
            url: '/cloud/search/admin/esSearch/esStopWordsPages',
            method: 'post',
            data
        })
    },
    // 停用词 分页列表
    deleteEsStopWords: (params) => {
        return service({
            url: '/cloud/search/admin/esSearch/deleteEsStopWords',
            method: 'delete',
            params
        })
    },
    // 停用词 上下架
    changeEsStopWords: (params) => {
        return service({
            url: '/cloud/search/admin/esSearch/changeEsStopWords',
            method: 'put',
            params
        })
    },
    /** 搜索明细 */
    // 搜索明细 分页列表
    searchQueryLogPages: (params) => {
        return service({
            url: '/cloud/search/admin/esSearch/searchQueryLogPages',
            method: 'get',
            params
        })
    },
    /** 搜索结果 */
    // 搜索结果 分页列表
    searchResultClickLogPages: (params) => {
        return service({
            url: '/cloud/search/admin/esSearch/searchResultClickLogPages',
            method: 'get',
            params
        })
    },
    /** 导出 */
    // 停用词导出
    exportEsStopWords: (params) => {
        return service({
            url: '/cloud/search/admin/esSearch/exportStopWordsExcel',
            method: 'get',
            params,
            responseType: 'blob'
        })
    },
    // 扩展词导出
    exportEsExtWords: (params) => {
        return service({
            url: '/cloud/search/admin/esSearch/exportExtWordsExcel',
            method: 'get',
            params,
            responseType: 'blob'
        })
    },
    // 近义词导出
    exportEsSynonymWords: (params) => {
        return service({
            url: '/cloud/search/admin/esSearch/exportSynonymWordsExcel',
            method: 'get',
            params,
            responseType: 'blob'
        })
    },
    // 搜索明细导出
    exportSearchQueryLog: (params) => {
        return service({
            url: '/cloud/search/admin/esSearch/exportSearchQueryLogExcel',
            method: 'get',
            params,
            responseType: 'blob'
        })
    },
    // 搜索结果导出
    exportSearchResultClickLog: (params) => {
        return service({
            url: '/cloud/search/admin/esSearch/exportSearchResultClickLogExcel',
            method: 'get',
            params,
            responseType: 'blob'
        })
    },

}


// WEBPACK FOOTER //
// ./src/api/contentManage/search.js